var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('div',{staticClass:"scrollable-content"},[_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"form-check"},[_vm._t("settlement")],2)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }